var countProduct = 0;
var $boxGridProduct = $('.box-grid-projects');

$(document).ready(function() {
  squareBoxProductsLanding();
  $boxGridProduct.children('.box-product-landing').each(function() {
    countProduct++;
  });
  checkLayoutProduct();
});

$(window).on('resize', function() {
  squareBoxProductsLanding();
  checkLayoutProduct();
});

function checkLayoutProduct() {
  var windowWidth = $(window).width();

  removeEmptyProduct();

  if (windowWidth > 767) {
    if (windowWidth > 991) {
      if (windowWidth > 1199) {
        if (windowWidth > 1599) {
          addPaddingRightProduct(8);
          addPaddingBottomProduct(8);
          if (checkBorderTopContainer(8)) {
            addEmptyProduct(8, windowWidth);
          } else {
            addOneEmptyProduct(8, windowWidth);
          }
        } else {
          addPaddingRightProduct(4);
          addPaddingBottomProduct(4);
          if (checkBorderTopContainer(4)) {
            addEmptyProduct(4, windowWidth);
          } else {
            addOneEmptyProduct(4, windowWidth);
          }
        }
      } else {
        //ipad Landscape 33%
        addPaddingRightProduct(3);
        addPaddingBottomProduct(3);
        if (checkBorderTopContainer(3)) {
          addEmptyProduct(3, windowWidth);
        } else {
          addOneEmptyProduct(3, windowWidth);
        }
      }
    } else {
      //ipad portrait 50%
      addPaddingRightProduct(2);
      addPaddingBottomProduct(2);
      if (checkBorderTopContainer(2)) {
        addEmptyProduct(2, windowWidth);
      } else {
        addOneEmptyProduct(2, windowWidth);
      }
    }
  } else {
    addPaddingRightProduct(1);
    addPaddingBottomProduct(1);
  }
}

function checkBorderTopContainer(nForLine) {
  if (nForLine > countProduct) {
    return false;
  } else {
    return true;
  }
}

function addPaddingBottomProduct(numbToAdd) {
  var borderBottomToAdd = parseInt(countProduct % numbToAdd);

  if (numbToAdd == 1) {
    borderBottomToAdd++;
  }
  if (!borderBottomToAdd) {
    borderBottomToAdd = numbToAdd;
  }
  $(
    $('.box-grid-projects').children('.box-product-landing').get().reverse()
  ).each(function() {
    if (borderBottomToAdd || mobile) {
      $(this).addClass('border-bottom');
      borderBottomToAdd--;
      mobile = false;
    }
  });
  squareBoxProductsLanding();
}

function addPaddingRightProduct(numbToAdd) {
  var borderRightToAdd =
    parseInt(countProduct % numbToAdd) + parseInt(countProduct / numbToAdd);
  var c = 1;
  $('.box-grid-projects').children('.box-product-landing').each(function() {
    if (c % numbToAdd == 0) {
      $(this).addClass('border-right');
    }
    c++;
  });
}
function addEmptyProduct(divider, windowWidth) {
  var mod = countProduct % divider;
  if (mod != 0) {
    var divToAdd = divider - mod;
    var html = '';
    for (var i = 0; i < divToAdd; i++) {
      if (i == 0) {
        html += "<div class='empty box-product-landing border-left'></div>";
      } else {
        html += "<div class='empty box-product-landing'></div>";
      }
    }

    $boxGridProduct.append(html);
    squareBoxProductsLanding();
  }
}

function addOneEmptyProduct(divider, windowWidth) {
  var html = "<div class='empty box-product-landing border-only-left'></div>";
  $boxGridProduct.append(html);
  squareBoxProductsLanding();
}
function removeEmptyProduct() {
  $boxGridProduct.children('.box-product-landing').each(function() {
    $(this).removeClass('border-bottom');
    $(this).removeClass('border-right');
    if ($(this).hasClass('empty')) {
      $(this).remove();
    }
  });
}
function squareBoxProductsLanding() {
  var height = $('.box-grid-projects .box-product-landing').width();
  $('.box-grid-projects .box-product-landing').each(function() {
    if ($(this).hasClass('border-only-left')) {
      $(this).height(height + 10);
    } else {
      $(this).height(height);
    }
  });
}



//////////////////
// WEBPACK FOOTER
// ./assets/js/partials/_products-landing.js
// module id = 14
// module chunks = 0